// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#labdaq .el-table table thead tr th .cell {\n  padding: 3px 15px !important;\n}\n#labdaq .el-table table tbody tr td .cell {\n  padding: 5px 15px !important;\n}", ""]);
// Exports
module.exports = exports;
